import { Autocomplete, Folder } from '../../models';
import {
  CategoryAutocompletes,
  SearchCategoryAutocomplete,
} from '../../models/search/searchCategory';

export class FolderAutocomplete implements SearchCategoryAutocomplete {
  constructor() {}

  private static getAutocomplete(item: Folder): Autocomplete {
    const id: string = item?.id;

    return {
      name: item?.name,
      id,
    };
  }

  static getAutocompleteResult(autocompleteList: CategoryAutocompletes): Autocomplete[] {
    return (autocompleteList as Folder[]).map((folder: Folder) =>
      FolderAutocomplete.getAutocomplete(folder),
    );
  }
}
